import React from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { finalQuestions, finalStack, mockupUrl, offerAnchor, productName } from '../data/content';
import { pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function FinalClose() {
  return <section className="bg-blush-100 px-4 py-12 md:py-16" data-id="element-80" data-mp="i69de1q4mm4d">
      <div className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="1fsghlaiiqcg7">
        <p className="text-[11px] font-black uppercase tracking-[.25em] text-berry-700 md:text-xs" data-id="element-82" data-mp="1fs6rlmxh45ai">One last question...</p>
        <h2 className="mx-auto mt-3 max-w-2xl text-xl font-black uppercase leading-snug text-plum-950 md:text-3xl" data-id="element-83" data-mp="1avzgzgu4u5m8">
          What would you make first if you had 105 crochet patterns ready to follow?
        </h2>
        <ul className="mx-auto mt-5 max-w-xl space-y-1 text-sm italic text-plum-900 md:text-base" data-id="element-84" data-mp="1yj7n20zdxipb">
          {finalQuestions.map(question => <li key={question} data-id="element-85" data-mp="1trpm3cxd3i4c">{question}</li>)}
        </ul>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-muted md:text-base" data-id="element-86" data-mp="nosquekfd04i">
          With the <strong className="text-plum-950" data-id="element-87" data-mp="sootoahdylih">{productName}</strong>, you'll have plenty of projects to choose
          from. You already have the crochet skills.
        </p>
        <p className="mt-2 text-sm font-black uppercase tracking-wide text-berry-700 md:text-base" data-id="element-88" data-mp="iym1gci39bl7">
          Now it's time to explore beautiful new designs.
        </p>

        <ul className="mx-auto mt-6 space-y-1" data-id="element-89" data-mp="4xjezyn6lz9r">
          {finalStack.map(line => <li key={line} className="font-display text-base font-black uppercase text-plum-950 md:text-xl" data-id="element-90" data-mp="91zijt9boult">
              {line}
            </li>)}
        </ul>

        <OfferLink className="mx-auto mt-8 max-w-[300px]" href={offerAnchor} label={`${productName} offer`} data-id="element-91" data-mp="3w4chd5tpo4fv">
          <img src={mockupUrl} alt={`${productName} 3D product mockup`} className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-92" data-mp="1pfzgiyolya6f" />
        </OfferLink>

        <p className="mt-6 font-display text-xl font-black uppercase text-plum-950 md:text-2xl" data-id="element-93" data-mp="1nxseqhyh62q7">{productName}</p>
        <p className="mt-1 text-sm font-black uppercase tracking-wide text-berry-700" data-id="element-94" data-mp="1ixwbikxlqfbp">
          5 Complete Volumes + 5 FREE Bonuses
        </p>
        <p className="mt-2 text-sm font-semibold text-plum-900" data-id="element-95" data-mp="1e15v1whvxhpr">105 Crochet Patterns for Bags &amp; Accessories</p>

        <p className="mt-6 text-sm font-black uppercase tracking-wide text-plum-950 md:text-base" data-id="element-96" data-mp="2bp64qh95lm80">
          Get instant access for just <span className="text-berry-600" data-id="element-97" data-mp="21x0htlxrduzo">${pricing.price} USD</span>
        </p>
        <div className="mt-4" data-id="element-98" data-mp="21uxk0fqd6xke">
          <Button href={offerAnchor} size="lg" subtext="Instant Digital Access • Downloadable PDF Files" data-id="element-99" data-mp="1wyyyczwf7tno">
            Yes! I want my crochet collection!
          </Button>
        </div>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-plum-900" data-id="element-100" data-mp="2pn4j3mnh5ini">
          <li className="flex items-center gap-1.5" data-id="element-101" data-mp="2xwtrvggm6tse">
            <LockIcon className="h-4 w-4 text-berry-600" aria-hidden="true" data-id="element-102" data-mp="31wu733bjf90i" /> Secure Checkout
          </li>
          <li className="flex items-center gap-1.5" data-id="element-103" data-mp="36wgn1kir33d0">
            <ShieldCheckIcon className="h-4 w-4 text-berry-600" aria-hidden="true" data-id="element-104" data-mp="36uvqxqgsfcd1" /> 7-Day Guarantee
          </li>
        </ul>
      </div>
    </section>;
}